export default __webpack_public_path__ + "static/media/Jahaz-Mahal.40801dbf.jpg";